<div class="grid__cell grid__cell--widget grid__cell--widget-dashboard widget__bag"
     [dragula]='"widget-bag"'>
  <div class="widget__wrap">
    <div class="widget"
         id="categories-widget">
      <h2 class="widget__header">
        <span class="widget__header__title">
          <i class="widget__header__icon ico-angle-down"></i> Certifikáty</span>
        <span class="widget__header__tools">
          <swb-filter-list (modelChange)="filterCerts($event)"></swb-filter-list>
          <a [routerLink]="['certs/add']"
             class="cta cta--small cta--green">
            <span class="cta__light">Přidat</span> certifikát
            <i class="ico-plus"></i>
          </a>
        </span>
      </h2>
      <div class="widget__content">
        <swb-cert-list [query]="certQuery"></swb-cert-list>
      </div>
    </div>
  </div>
</div>
<div class="grid__cell grid__cell--widget grid__cell--widget-dashboard widget__bag"
     [dragula]='"widget-bag"'>
  <div class="widget__wrap">
    <div class="widget"
         id="categories-widget">
      <h2 class="widget__header">
        <span class="widget__header__title">
          <i class="widget__header__icon ico-angle-down"></i> Granty</span>
        <span class="widget__header__tools">
          <swb-filter-list (modelChange)="filterGrants($event)"></swb-filter-list>
          <a [routerLink]="['grants/add']"
             class="cta cta--small cta--green">
            <span class="cta__light">Přidat</span> grant
            <i class="ico-plus"></i>
          </a>
        </span>
      </h2>
      <div class="widget__content">
        <swb-grant-list [query]="grantQuery"></swb-grant-list>
      </div>
    </div>
  </div>
</div>